import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IUpdateParametrizacao } from './parametrizacao.model';

@Injectable({
  providedIn: 'root'
})
export class ParametrizacaoService {
  constructor(private http: HttpClient) {}

  public GetParametrizacaoById(id: number): Observable<any> {
    let url = `${environment.baseURL}Parametrizacao/GetParametrizacaoById?IdParametrizacao=${id}`;
    return this.http.get<any>(url);
  }

  public GetParametrizacaoByName(name: string): Observable<any> {
    let url = `${environment.baseURL}Parametrizacao/GetParametrizacaoByName?name=${name}`;
    return this.http.get<any>(url);
  }

  public UpdateParametrizacao(body: IUpdateParametrizacao): Observable<any> {
    const url = `${environment.baseURL}Parametrizacao/UpdateParametrizacao`;
    return this.http.put<any>(url, body);
  }
}
